import moment from "moment";

import "moment/locale/pt-br";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCircle,
    faChartBar,
    faHashtag,
} from "@fortawesome/free-solid-svg-icons";

import Table from "../../../../Components/Table";
import ModalComponent from "../../../../Components/Modais";

import { TModoGestaoAtendimento } from "../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";

import {
    ExportarExcelAtendimentosClienteController,
    ListarAtendimentosParaTransferirController,
} from "../../../../Controllers/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoControllers";
import { ACESSOS } from "../../../../Routes/Acessos";
import ExportExcel from "../../../../Components/StickyToolbar/ExportExcel";
import TransferirTodosAtendimento from "../../../../Components/CardsPages/Atendimento/TransferirTodosAtendimentos";
import "./styles.css";
import FiltroAtendimentos from "./FiltroAtendimentos";
import useAtendimento from "./useAtendimento";
import ElementosTableAtendimentoCliente from "./FiltroAtendimentos/elementosTable";
// import { Switch } from "../../../../Components/CardsPages/Forms/Switch";

// interface IPropsTableChange extends TableChangeState<any> {
//     searchText: string;
// }

interface IAtendimentosAoClienteProps {
    atendimento: TModoGestaoAtendimento;
}

function AtendimentosAoCliente(props: IAtendimentosAoClienteProps) {
    moment.locale("pt-br");

    const {
        show,
        setShow,
        modal,
        setModal,
        listarClientes,
        updateList,
        filter,
        FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE,
        filtroGestaoStorage,
        setPage,
        totalPaginas,
        listarClientesLoading,
    } = useAtendimento(props.atendimento);

    const { atendimentoColumns, tableviewColumns } =
        ElementosTableAtendimentoCliente(
            props.atendimento,
            setShow,
            setModal,
            updateList
        );

    return (
        <div className="card card-custom">
            <div className="d-flex flex-row px-4 pt-4 justify-content-around">
                <div className="px-4 pt-1 pb-2 bg-primary rounded text-white">
                    <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-2x">
                            <FontAwesomeIcon icon={faChartBar} />
                        </span>
                        <span className="card-title font-weight-bolder text-white-75 font-size-h2 text-center mt-1 mb-2 ml-2">
                            {listarClientes?.NR_CASOS}
                        </span>
                    </div>
                    <span className="font-weight-bold font-size-sm">
                        Total de Atendimentos
                    </span>
                </div>
                <div className="px-4 pt-1 pb-2 bg-info rounded text-white">
                    <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-2x">
                            <FontAwesomeIcon icon={faCircle} />
                        </span>
                        <span className="card-title font-weight-bolder text-white-75 font-size-h2 text-center mt-1 mb-2 ml-2">
                            {listarClientes?.NR_CASOS_EM_DIA}
                        </span>
                    </div>
                    <span className="font-weight-bold font-size-sm">
                        Atendimento no Prazo
                    </span>
                </div>
                <div className="px-4 pt-1 pb-2 bg-danger rounded text-white">
                    <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-2x">
                            <FontAwesomeIcon icon={faHashtag} />
                        </span>
                        <span className="card-title font-weight-bolder text-white-75 font-size-h2 text-center mt-1 mb-2 ml-2">
                            {listarClientes?.NR_CASOS_EM_ATRASO}
                        </span>
                    </div>
                    <span className="font-weight-bold font-size-sm">
                        Atendimento Atrasados
                    </span>
                </div>
            </div>
            <div className="card-body mt-n2 table-responsive">
                <Table
                    columns={atendimentoColumns}
                    data={listarClientes?.ATENDIMENTOS ?? []}
                    keyField="ID_CASO"
                    onTableChange={(type, newState) => {
                        setPage(newState.page);
                    }}
                    tableView={{
                        columns: tableviewColumns,
                        noSort: true,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                    }}
                    remote={{ pagination: true }}
                    totalPages={totalPaginas}
                    loading={listarClientesLoading}
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhum Atendimento encontrado
                        </div>
                    )}
                    noHover
                    noSearch
                    bordered={false}
                />
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />

            <FiltroAtendimentos
                atendimento={props.atendimento}
                filter={filter}
                FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE={
                    FILTRO_GESTAO_ATENDIMENTOS_AO_CLIENTE
                }
                filtroGestaoStorage={filtroGestaoStorage}
                updateList={updateList}
            />

            <ExportExcel
                baixarExcelController={async () =>
                    ExportarExcelAtendimentosClienteController(
                        filter.current,
                        0,
                        props.atendimento
                    )
                }
                nomeArquivo={"Atendimento_Cliente"}
            />

            <TransferirTodosAtendimento
                ID_TIPO_CASO={ACESSOS.ATENDIMENTO.ID_MODULO}
                filter={filter.current}
                setShow={setShow}
                update={() => {
                    updateList(filter.current, 1, props.atendimento);
                }}
                controller={() =>
                    ListarAtendimentosParaTransferirController(
                        filter.current,
                        0,
                        props.atendimento
                    )
                }
            />
        </div>
    );
}

export default AtendimentosAoCliente;
